import React from 'react'

function Opciones({...r}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" {...r}>
      <path
        stroke="#126FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M42.98 2.5v2.79m6.67-.92L48.28 6.8m6.26 2.49l-2.39 1.44m4.22 5.25l-2.79.07M36.32 4.37L37.7 6.8m-6.26 2.49l2.39 1.44m7.14 17.4h4.02m4.16-12.1c0-3.4-2.75-6.15-6.15-6.15-3.4 0-6.15 2.75-6.15 6.15 0 2.5 1.38 4.65 3.53 5.61v3.2h5.12v-3.2a6.146 6.146 0 003.65-5.61z"
      ></path>
      <path
        stroke="#00033A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M34.68 46.86v3.72c0 1.91-1.55 3.46-3.46 3.46h-2.47c-1.91 0-3.46-1.55-3.46-3.46v-3.72M40.2 32.83v5.23c0 4.8-3.89 8.69-8.69 8.69h-3.05a8.69 8.69 0 01-8.69-8.69V28.02c0-4.8 3.89-8.69 8.69-8.69h3.05m3.72 30.75H39c2.01 0 3.96.92 5.09 2.58.64.94 1 2.04 1 3.22l-.01 4.93M24.74 50.08h-3.76c-2.01 0-3.96.92-5.09 2.58-.64.94-1 2.04-1 3.22l.01 4.93"
      ></path>
      <path
        stroke="#00033A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M24.61 39.41c1.33 1.47 3.24 2.41 5.38 2.41 2.14 0 4.05-.94 5.38-2.41m-.17-15.62c-2.17 5.44-7.49 9.28-13.7 9.28h-1.4"
      ></path>
    </svg>
  )
}

export default Opciones